import { t } from '@/features/i18n/utils';
import { Outlet } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { Main } from '@/ui/components/main';
import { Icon } from '@/ui/components/icon';
import {
  Building06Icon,
  InboxIcon,
  Search01Icon,
  SparklesIcon,
  SquareCheckBigIcon,
} from '@hugeicons-pro/core-stroke-rounded';
import {
  BottomNavigation,
  BottomNavigationButton,
  BottomNavigationLink,
  BottomNavigationList,
} from '@/ui/components/bottom-navigation';
import { FilePreviewSheet } from '@/features/documents/preview/components/file-preview-sheet';
import { globalSearchOpenAtom } from '@/features/search/store';
import { useSetAtom } from 'jotai';
import { OrganizationSidebar } from '@/features/organizations/components/organization-sidebar';

export const Route = createFileRoute('/_authed/_organization')({
  component: RouteComponent,
});

function RouteComponent() {
  const setSearchOpen = useSetAtom(globalSearchOpenAtom);

  return (
    <div className="flex max-md:flex-col grow min-w-0 bg-background">
      <OrganizationSidebar />
      <Main>
        <Outlet />
      </Main>
      <FilePreviewSheet />
      <BottomNavigation>
        <BottomNavigationList className="grid-cols-5">
          <BottomNavigationLink to={'/'}>
            <Icon icon={Building06Icon} />
            {t({ en: 'Projects', nb: 'Prosjekter' })}
          </BottomNavigationLink>
          <>
            <BottomNavigationButton onClick={() => setSearchOpen(true)}>
              <Icon icon={Search01Icon} />
              {t({ en: 'Search', nb: 'Søk' })}
            </BottomNavigationButton>
            <BottomNavigationLink to={'/notifications'}>
              <Icon icon={InboxIcon} />
              {t({ en: 'Notifications', nb: 'Notifikasjoner' })}
            </BottomNavigationLink>
            <BottomNavigationLink to={'/my-tasks'}>
              <Icon icon={SquareCheckBigIcon} />
              {t({ en: 'My tasks', nb: 'Mine oppgaver' })}
            </BottomNavigationLink>
            <BottomNavigationLink to={'/learnings'}>
              <Icon icon={SparklesIcon} />
              {t({ en: 'Learnings', nb: 'Erfaringer' })}
            </BottomNavigationLink>
          </>
        </BottomNavigationList>
      </BottomNavigation>
    </div>
  );
}
